<template>
  <div id="event-information-detail">
    <call />
    <!-- main -->
    <main>
      <!-- shop -->
      <section>
        <div class="l-shop l-shop--dark-grey pt-0">
          <div class="l-shop__head l-shop__head--pd pt-12">
            <div v-on:click="backPagePrevious" class="l-shop__head--icon">
              <img src="/assets/images/icon/icon-back.svg" alt="" />
            </div>
            <div class="l-shop__head--title l-shop__head--auto">イベント</div>
            <div class="l-shop__head--icon"></div>
          </div>
        </div>
      </section>
      <!-- list -->
      <section :class="{'fade-base': true, 'fade': pageFade}">
        <div class="l-shop-deal bg-white pb-38">
          <!-- list new -->
          <ul class="c-list-deal c-list-deal--xl has-full">
            <li>
              <div class="c-list-deal__item">
                <div v-if="event.provider && event.provider.id != SHOP_ID">
                <div class="c-list-deal__shop" @click.prevent="shopTop(event.provider)" >
                  <div v-if="event.provider" class="c-list-deal__shop--img">
                    <img :src="getImgSrc(event.provider.image[0])" alt="" />
                  </div>
                  <div v-if="event.provider" class="c-list-deal__shop--name">
                    {{ event.provider.shopName }}
                  </div>
                </div>
                </div>
                
                <div v-else>
                  <div class="c-list-deal__shop--name" style="margin: 8px">
                    イオン・全館
                  </div>
                </div>
                <template v-if="event.image && event.image.length > 0">
                <div class="swiper-container js-swiper_tab_body">
                  <div class="swiper-wrapper">
                    <div class="c-list-deal__img js-keep-ratio swiper-slide" data-ratio="0.746" v-for="img in event.image" :key="img">
                      <img v-bind:src="getImgSrc(img)" alt="">
                    </div>
                  </div>
                </div>
                </template>
                <div v-else class="c-list-deal__img js-keep-ratio" data-ratio="0.746">
                  <img src="/assets/images/aeontown-noimg.png" alt="">
                </div>
                <div class="swiper-pagination" v-if="event.image && event.image.length > 1"></div>
                <div class="c-list-deal__info">
                  <div class="c-list-deal__info--head mb-12">
                    <div class="c-tag c-tag--blue c-tag--xl">
                      イベント
                    </div>
                    <div class="c-list-deal__info--period" v-html="formatEventTerm(event)"></div>
                    <div v-if="favoriteEventExists(event.id)" class="c-heart c-heart--xl is-active" v-on:click="deleteFavorite(event, EVENT_COLLECTION_KEY, event.provider)">
                      <svg width="30" height="27" class="c-heart__active">
                        <use xlink:href="#ic-icon-heart-active" />
                      </svg>
                    </div>
                    <div v-else class="c-heart c-heart--xl"  v-on:click="addFavorite(event, EVENT_COLLECTION_KEY, event.provider)">
                       <svg width="30" height="27" class="c-heart__unactive">
                         <use xlink:href="#ic-icon-heart" />
                        </svg>
                    </div>
                  </div>
                  <div class="c-list-deal__info--time">
                    <img v-if="isNew(event.discloseAt)" src="/assets/images/icon/icon-new.svg" alt="" />
                    <span v-if="event.eventStartAt" >{{ formatDateTime(event.eventStartAt) }}</span>
                  </div>
                  <div class="postDetail__info" v-if="event.time || event.place">
                    <div class="postDetail-title" v-if="event.time">時間</div>
                    <div class="postDetail-text" v-if="event.time" v-html="formatTimeandPlace(event.time)" />
                    <div class="postDetail-title" v-if="event.place">場所</div>
                    <div class="postDetail-text" v-if="event.place" v-html="formatTimeandPlace(event.place)" />
                  </div>
                  <div class="c-list-deal__info--content" >
                    <div v-if="event.content" v-html="autolink(event.content)"></div>
                    <div v-else v-html="event.title"></div>

                    <div v-if="event.qerLoginRequired && qerUrl && !isUserLoggedIn()" class="c-list-deal__info--content">
                      <p class="color-4">こちらのサービスを利用するには、ログインが必要です。</p>
                    </div>
                    <div v-if="qerUrl" >
                      <router-link v-if="event.qerLoginRequired && !isUserLoggedIn()" to="/account/profile" class="c-btn c-btn--red mt-16 box-center">ログインはこちら</router-link>
                      <a v-else v-bind:href="qerUrl" class="c-btn c-btn--red mt-16 box-center ext-link">アンケートに回答する</a>
                    </div>

                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-on:click="backList" class="c-btn-check l-shop-deal__box-back box-center">
            <div class="l-shop-deal__box-back--icon">
              <img src="/assets/images/icon/icon-back.svg" alt="" />
            </div>
            <div class="l-shop-deal__box-back--title">一覧へ戻る</div>
            <div class="l-shop-deal__box-back--icon"></div>
          </div>
        </div>
      </section>
      <section>
        <modal_login_required></modal_login_required>
      </section>
       <alert :message="alert_msg" 
        :show="alert_show" 
        :closeModal="closeModal" 
        :confirm_show="confirm_show" 
        :confirm_message="confirm_msg" 
        :confirm_callback="confirm_callback" 
        :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel"
        :label_ok="confirm_label_ok"
        :set_cover="true"
        ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import Swiper, { Pagination } from "swiper";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getEventDetail,getShop } from "../store/firestore.js";
import { DB, EVENT_COLLECTION_KEY } from "../config/const.js";
const $ = window.$;
import Alert from "../components/Alert.vue";

Swiper.use(Pagination);

export default Vue.extend({
  name: "EventDetail",
  components: {
    'modal_login_required': ModalLoginRequired,
    Alert,
  },
  mixins: [Tenant],
  data () {
    return {
      eventId: this.$route.params.id,
      eventProviderId: this.$route.params.eventProviderId,
      event: {},
      qerUrl: "",
      EVENT_COLLECTION_KEY: EVENT_COLLECTION_KEY
    }
  },
  async created () {
    // pushからのshopId付きの起動
    let shopId = Common.getUrlParam('shopId');
    if (shopId && shopId != this.$store.state.shopId) {
      const shop = await getShop(shopId);
      const res =  await this.confirm(`${shop.name}\n\nこの店舗に表示を切り替える`, false, { ok_label: 'はい', cancel_label: 'いいえ' });
      if (res) {
        await this.$store.dispatch('setShopId', shopId);
        location.reload()
      } else {
        this.$router.push('/top');
      }
    }

    await this.getDateEventDetail(this.eventId, this.eventProviderId)
    const now = Date.now();
    if (!this.event || this.event.publishStatus != 2 
    || this.event.discloseAt > now || (this.event.closeAt && this.event.closeAt < now)
    || (this.event.provider && this.event.provider.id != this.SHOP_ID && this.event.authorizeStatus != 2)) {
      this.$router.push('/events');
    }
    this.swiper = new Swiper('.js-swiper_tab_body', {
      slidesPerView: 1,
      observer: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      }
    })
    $('.c-list-deal__info--content a').addClass('ext-link');
    if (this.event.source == 'aeontown.co.jp') {
      $('.c-list-deal__info--content img').addClass('w-100');
    }
    if (this.event.qerUrl) {
      let url = new URL(this.event.qerUrl);
      url.searchParams.append('uid', this.$store.state.userId);
      this.qerUrl = url;
    }
  },
  mounted() {
    Common.initDom();
  },
  updated() {
      this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async getDateEventDetail (eventId, eventProviderId) {
      const result = await getEventDetail(eventId, eventProviderId)
      if (!result) return
      this.event = result
    },
    shopTop(provider) {
      if (!provider || !provider.id) return;
      this.$router.push('/shop/detail/'+provider.id);
    },
    backList() {
      const referrer = this.$router.referrer;
      if (referrer && (referrer.name == "Events" || referrer.name == "ShopDetail"))  {
        this.$router.back();
      } else {
        this.$router.push('/events');
      }
    },
    formatTimeandPlace(str) {
      return str?.replace(/(\s|　)+/g, "<br />");
    }
  }
})
</script>
